<script lang="ts">
  import { faceGrinningSolidIcon, faceSmilingIcon } from '@nrk/core-icons';
  import { nrkLogo } from '@nrk/core-icons/logo';
  import { type Snippet } from 'svelte';
  import Breadcrumbs from '../components/Breadcrumbs.svelte';
  import ThemeToggle from '../components/ThemeToggle.svelte';
  import { loginWithMicrosoft, logout, user } from '../firebase/auth';
  import BildebankenHost from '../lib/bildebanken/BildebankenHost.svelte';
  import { p } from '../utils/router';

  interface Props {
    children: Snippet;
  }
  let { children }: Props = $props();
</script>

<header>
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  <a href={p('/')}><span class="logo">{@html nrkLogo}</span></a>
  <div class="header-actions">
    <ThemeToggle />
    {#if $user == null}
      <button onclick={loginWithMicrosoft}>
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        <span>{@html faceSmilingIcon}</span>Logg på</button
      >
    {:else}
      <button onclick={logout}>
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        {@html faceGrinningSolidIcon}{$user.displayName}</button
      >
    {/if}
  </div>
</header>
<main>
  {#if $user != null}
    <Breadcrumbs />
    {@render children()}
    <BildebankenHost />
  {:else}
    <div class="welcome">
      <h1>Velkommen til Gjettekonken Admin</h1>
      <p>Logg inn for å administrere turneringer, runder og spørsmål.</p>
      <button class="login-btn" onclick={loginWithMicrosoft}>
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        <span>{@html faceSmilingIcon}</span>Logg inn
      </button>
    </div>
  {/if}
</main>

<style>
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    margin: 0 auto;
    max-width: 1400px;
  }

  .logo {
    font-size: 1.5rem;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  button {
    display: flex;
    align-items: center;
    gap: 4px;
    border: none;
    background-color: transparent;
  }

  main {
    margin: 0 auto;
    padding: 0 1rem;
    max-width: 1400px;
  }

  .welcome {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    text-align: center;
    gap: 1.5rem;
  }

  .welcome h1 {
    font-size: 2rem;
    font-weight: 600;
    color: var(--color-text);
    margin: 0;
  }

  .welcome p {
    font-size: 1.1rem;
    color: var(--color-text);
    opacity: 0.8;
    margin: 0;
    max-width: 500px;
  }

  .login-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    border: 1px solid var(--color-border);
    background: var(--color-button-bg);
    color: var(--color-button-text);
    border-radius: 6px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.2s;
  }

  .login-btn:hover {
    background: var(--color-hover);
    border-color: #1a5c2a;
    color: #1a5c2a;
  }

  .login-btn span {
    display: flex;
    font-size: 1.25rem;
  }
</style>
